import { render, staticRenderFns } from "./UserGroupPermissions.vue?vue&type=template&id=7f381386&scoped=true"
import script from "./UserGroupPermissions.vue?vue&type=script&lang=js"
export * from "./UserGroupPermissions.vue?vue&type=script&lang=js"
import style0 from "./UserGroupPermissions.vue?vue&type=style&index=0&id=7f381386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f381386",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Pages/UserGroupPermissions.vue
// module id = 2271
// module chunks = 31